<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<dash-gis-flexible-panel [panelTitle]="'Search Results'"
          (panelBack)="backToSearch.emit()"
          [enableResize]="true"
          (closePanel)="closeResults.emit()">
    <div class="dash-gis-search-results-container report-box" fxFlex fxLayout="column" fxLayoutAlign="start stretch">
        <div fxFlex fxLayout="column">
            <dash-gis-search-results-content [instanceId]="instanceId" fxLayout="column"></dash-gis-search-results-content>
        </div>
    </div>
</dash-gis-flexible-panel>
